export const FormControlsTokens = {
  "color": {
    "background": {
      "onlight": {
        "value": "#ffffff"
      },
      "ondark": {
        "value": "#000000"
      }
    },
    "border": {
      "onlight": {
        "value": "#6f7171"
      },
      "ondark": {
        "value": "#a7a7a7"
      },
      "hover": {
        "onlight": {
          "value": "#000000"
        },
        "ondark": {
          "value": "#ffffff"
        }
      },
      "readonly": {
        "onlight": {
          "value": "#d8dada"
        },
        "ondark": {
          "value": "#333333"
        }
      }
    }
  },
  "border": {
    "radius": {
      "value": "0.25rem"
    },
    "width": {
      "value": "0.0625rem"
    }
  },
  "space": {
    "inset": {
      "value": "0.75rem"
    }
  }
}